import CartController from "emun.cart/cart.controller";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import PrintOrderOptions from "emun.order/order-print";
import orderConfig from "emun.order/order.config";
import config from "emun.retailer/retailer.config";
import templateUrl from "emun.shopping.admin/admin-order-one-up.htm";

class OrderOneUpController extends CartController {
  constructor($cart) {
    super($cart);
    this.hideParcels = config.hideParcels === true;
    this.hideTracking = config.hideTracking === true;
    this.hideRefund = config.hideRefund === true;
    this.$itemOrderBy = "position";
    this.orderConfig = orderConfig;
    this.itemSortOptions = {
      position: "Position",
      description: "Description",
      price: "Price",
      productId: "Sku",
    };
  }
  downloadImagesPrompt(ext) {
    return DownloadImagesPrompt({
      subTitle: this.order.id + " - " + this.companyName,
      id: this.order.id,
    });
  }

  printOrder(order) {
    const $ctrl = this;
    return PrintOrderOptions({
      request: {
        id: order,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }
  modify() {
    const $ctrl = this;
    return $ctrl.$cart
      .openModifyOrder()
      .then(() => $ctrl.$cart.load($ctrl.order.id));
  }
  export() {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "SalesOrderLinesExport?OrderNumber=" + $ctrl.order.id
    );
    return (location.href = url);
  }
  exportWithImages() {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=OrderExport&displayName=OrderExport&output=xlsx&orderNumber=" +
        $ctrl.order.id
    );
    return (location.href = url);
  }
  exportQuickReport(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.order.id
    );

    return (location.href = url);
  }
  exportQuickReportImages(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.order.id +
        "&expandKits=True&displayImage=True"
    );
    //console.info("url", url);
    return (location.href = url);
  }
}

export default class OrderOneUp {
  constructor() {
    this.bindings = {
      order: "<",
    };
    this.controller = OrderOneUpController;
  }

  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
}
